module.exports = __webpack_public_path__ + "img/heart_240px.1a1c8015.png";